import bonusModule from '../scripts/bonus/bonusPage.module.js';

import appDependency from '../scripts/appDependency.js';

appDependency.addItem(bonusModule);
